<template>
  <b-row class="justify-content-center">
    <b-col cols="12" class="mt-3">
      <div>
      <b-row>
      <b-col cols="12" class="d-flex justify-content-end mt-3">
        <b-button class="btnFilter_2">
          <i class="fa-light fa-upload"></i>
          {{ $t('mandate.upload_signed_mandate') }}
        </b-button>
      </b-col>
      </b-row>
        <!-- Mandate info (écriture côté créancier) -->
        <form-accordion v-if="type !== 'dbtr'" :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
          <div style="padding-top: 1.5rem; padding-bottom: 1.5rem;">
          <b-row class="ml-0 mb-4 mr-5 form-group">
            <b-col sm="5">
              <label>
                {{ $t('mandate.schema') }} <span style="color: red">*</span>
              </label>
              <select class="form-control" id="sel4" v-model="active_schema" :disabled="isDisabled">
                <option value="core">{{ $t('mandate.core') }}</option>
                <option value="b2b">{{ $t('mandate.b2b') }}</option>
              </select>
            </b-col>
            <b-col sm="5">
              <label>
                {{ $t('mandate.tx_type') }} <span style="color: red">*</span>
              </label>
              <select class="form-control" id="sel4" v-model="active" :disabled="isDisabled">
                <option value="one_off">{{ $t('mandate.one_off') }}</option>
                <option value="recurrent">{{ $t('mandate.recurrent') }}</option>
              </select>
            </b-col>
          </b-row>

          <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                v-model="ctr"
                :inputLabel="$t('mandate.underlying_contract_id')"
                :disabled="isDisabled">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5" v-if="showUmrControls">
              <b-row class="ml-1 form-group">
                <label class="d-block mb-2">Unique Mandate References</label>
              </b-row>
              <b-row class="ml-2 mt-4 mb-4 mr-5 form-group">
                  <b-col sm="1">
                    <b-form-checkbox
                      id="umrAuto"
                      :checked="umrAutoChecked"
                      @change="onUmrAutoChange"
                    >
                      {{ $t('mandate.umr_auto') || 'Gérer automatiquement' }}
                    </b-form-checkbox>
                  </b-col>
                  <b-col sm="6">
                    <b-row class="form-group">
                      <b-form-checkbox
                        id="umrManual"
                        :checked="umrManualChecked"
                        @change="onUmrManualChange"
                        class="ml-2"
                      >
                        {{ $t('mandate.umr_manual') || 'Manuelle' }}
                      </b-form-checkbox>

                      <div class="ml-4 mt-3" v-if="umrManualChecked">
                        <input
                          class="form-control"
                          type="text"
                          :placeholder="$t('mandate.umr_placeholder') || 'Saisir le UMR…'"
                          v-model="umrManual">
                      </div>
                    </b-row>
                  </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ml-0 mb-4 mr-5 form-group">
            <b-col sm="5">
              <label for="mandate-language">  {{ $t('mandate.langue_mandat') }} <span style="color: red">*</span></label>
              <select id="mandate-language" class="form-control" v-model="mandateLang" :disabled="isDisabled">
                <option v-for="opt in mandateLanguageOptions" :key="opt.value" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </b-col>
          </b-row>
          </div>
        </form-accordion>

        <!-- Mandate info (lecture côté débiteur) -->
        <form-accordion v-if="type === 'dbtr'" :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-read-group-label-input
                :inputLabel="$t('mandate.underlying_contract_id')" :inputValue="ctr">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-read-group-label-input
                :inputLabel="$t('mandate.tx_type')" :inputValue="$t(`mandate.${active}`)">
              </form-read-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>

        <!-- Creditor info -->
        <form-accordion :title="$t('mandate.cdtr_info')" :isTitleUpperCase="false">
          <div style="padding-top: 1.5rem; padding-bottom: 1.5rem;">
          <!-- Ligne 1 : Nom / Identifiant -->
          <b-row class="ml-0 mb-4 mr-5 form-group">
            <b-col sm="5">
              <!-- ÉCRITURE côté créancier -->
              <form-write-group-label-input
                v-if="type !== 'dbtr'"
                v-model="cdtr_name"
                :inputLabel="$t('mandate.cdtr_name')"
                isMandatory>
              </form-write-group-label-input>

              <!-- LECTURE côté débiteur -->
              <form-read-group-label-input
                v-else
                :inputLabel="$t('mandate.cdtr_name')"
                :inputValue="cdtr_name">
              </form-read-group-label-input>
            </b-col>

            <b-col sm="5">
              <!-- ÉCRITURE côté créancier -->
              <form-write-group-label-input
                v-if="type !== 'dbtr'"
                v-model="cdtr_id"
                :inputLabel="$t('mandate.cdtr_id')"
                isMandatory>
              </form-write-group-label-input>

              <!-- LECTURE côté débiteur -->
              <form-read-group-label-input
                v-else
                :inputLabel="$t('mandate.cdtr_id')"
                :inputValue="cdtr_id">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <!-- Ligne 2 : cdtr_ref_* (déjà en écriture) -->
          <b-row class="ml-0 mt-2 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                v-model="cdtr_ref_name"
                :inputLabel="$t('mandate.cdtr_ref_name') || 'Creditor reference name'">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                v-model="cdtr_ref_id"
                :inputLabel="$t('mandate.cdtr_ref_id') || 'Creditor reference ID'">
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <!-- Ligne 3 : Adresse / Ville -->
          <b-row class="ml-0 mb-4 mr-5 form-group">
            <b-col sm="5">
              <!-- ÉCRITURE côté créancier -->
              <form-write-group-label-input
                v-if="type !== 'dbtr'"
                v-model="cdtr_addrss"
                :inputLabel="$t('mandate.cdtr_addrss')">
              </form-write-group-label-input>

              <!-- LECTURE côté débiteur -->
              <form-read-group-label-input
                v-else
                :inputLabel="$t('mandate.cdtr_addrss')"
                :inputValue="cdtr_addrss">
              </form-read-group-label-input>
            </b-col>

            <b-col sm="5">
              <!-- ÉCRITURE côté créancier -->
              <form-write-group-label-input
                v-if="type !== 'dbtr'"
                v-model="cdtr_city"
                :inputLabel="$t('mandate.cdtr_city')">
              </form-write-group-label-input>

              <!-- LECTURE côté débiteur -->
              <form-read-group-label-input
                v-else
                :inputLabel="$t('mandate.cdtr_city')"
                :inputValue="cdtr_city">
              </form-read-group-label-input>
            </b-col>
          </b-row>

          <!-- Ligne 4 : Pays -->
          <b-row class="ml-0 mr-5 form-group" style="margin-bottom: 1.5rem;">
            <b-col sm="5">
              <!-- ÉCRITURE côté créancier : liste déroulante -->
              <div v-if="type !== 'dbtr'">
                <label>{{ $t('mandate.cdtr_ctry') }}</label>
                <select
                  class="form-control"
                  v-model="cdtr_ctry"
                  @change="onCountryChange"
                >
                  <option
                    v-for="opt in countryOptions"
                    :key="opt.value"
                    :value="opt.value"
                  >
                    {{ $t('countries.' + opt.key) }}
                  </option>
                </select>
              </div>

              <!-- LECTURE côté débiteur -->
              <form-read-group-label-input
                v-else
                :inputLabel="$t('mandate.cdtr_ctry')"
                :inputValue="cdtr_ctry">
              </form-read-group-label-input>
            </b-col>
          </b-row>
          </div>
        </form-accordion>

        <!-- Debtor info (écriture côté créancier) -->
        <form-accordion v-if="type !== 'dbtr'" :title="$t('mandate.dbtr_info')" :isTitleUpperCase="false">
          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_email"
                :inputLabel="$t('mandate.dbtr_email')"
                isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_name"
                :inputLabel="$t('mandate.dbtr_name')"
                isMandatory>
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_addr"
                :inputLabel="$t('mandate.dbtr_addr')"
                isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_city"
                :inputLabel="$t('mandate.dbtr_city')"
                isMandatory>
              </form-write-group-label-input>
            </b-col>
          </b-row>

          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <label class="font-weight-bold">
                {{ $t('mandate.dbtr_ctry') }}
                <span style="color: red">*</span>
              </label>
              <select
                v-model="dbtr_ctry"
                class="form-control">
                <option
                  v-for="opt in countryOptions"
                  :key="'dbtr-' + opt.value"
                  :value="opt.value">
                  {{ $t('countries.' + opt.key) }}
                </option>
              </select>
            </b-col>

            <b-col sm="5">
              <form-write-group-label-input
                :value="dbtr_phone"
                @input="onPhoneInput"
                :inputLabel="$t('mandate.dbtr_phone')"
                isMandatory>
              </form-write-group-label-input>

              <small
                v-if="dbtr_phone"
                :class="isValidEuropeanPhone(dbtr_phone) ? 'text-muted' : 'text-danger'"
                class="d-block mt-1"
              >
                <template v-if="isValidEuropeanPhone(dbtr_phone)">
                  {{ $t('mandate.phone_valid') }}
                </template>
                <template v-else>
                  {{ $t('mandate.phone_invalid') }}
                </template>
              </small>

              <small v-else class="text-muted d-block mt-1">
                {{ $t('mandate.phone_hint') }}
              </small>
            </b-col>
          </b-row>

          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <label class="font-weight-bold mb-3">
                {{ $t('mandate.signature_mode') }}
                <span style="color: red">*</span>
              </label>

              <div>
                <b-form-radio
                  v-model="signatureMode"
                  name="signature-mode"
                  value="docusign"
                  class="mb-2">
                  {{ $t('mandate.signature_docusign') }}
                </b-form-radio>

                <div v-if="signatureMode === 'docusign' && showDocusignMode" class="ml-4 mt-2 mb-3">
                  <b-form-radio
                    v-model="docusignMode"
                    name="docusign-mode"
                    value="url"
                    class="mb-2">
                    URL
                  </b-form-radio>

                  <!--<b-form-radio
                    v-model="docusignMode"
                    name="docusign-mode"
                    value="sms">
                    SMS
                  </b-form-radio>-->
                </div>

                <b-form-radio
                  v-model="signatureMode"
                  name="signature-mode"
                  value="openwens">
                  {{ $t('mandate.Powens') }}
                </b-form-radio>
              </div>
            </b-col>

            <b-col sm="5" class="mb-5">
              <iban-input
                ref="dbtrIbanInput"
                v-model="dbtr_iban"
                :label="$t('mandate.dbtr_iban')"
                :required="false"
                :hint="$t('mandate.iban_hint') || ''"
              />
            </b-col>
          </b-row>
        </form-accordion>

        <!-- Debtor info (déjà côté débiteur) -->
        <form-accordion v-if="type === 'dbtr'" :title="$t('mandate.dbtr_info')" :isTitleUpperCase="false">
          <b-row class="ml-0 mt-4 mb-4 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_name"
                :inputLabel="$t('mandate.dbtr_name')" isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                v-model="dbtr_iban"
                :inputLabel="$t('mandate.dbtr_iban')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>

        <!-- Boutons -->
        <b-row v-if="type !== 'dbtr'" class="form-group justify-content-end">
          <b-col sm="2">
            <b-button
              v-if="!isSubmitting"
              variant="primary"
              :disabled="!isFormValid || isSubmitting"
              @click="onSend">
              <i class="fa-light fa-paper-plane" size="17px"></i>
              <span v-if="!isSubmitting">{{ $t('mandate.send') }}</span>
              <span v-else>{{ $t('common.sending') || 'Envoi…' }}</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="type === 'dbtr'" class="form-group justify-content-end">
          <b-col lg="2" offset-lg="8">
            <b-button variant="primary" size="lg" @click="editProfile">
              <span>{{ $t('mandate.accept') }}</span>
            </b-button>
          </b-col>
          <b-col sm="2">
            <b-button variant="primary">
              <span>{{ $t('mandate.refus') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import IbanInput from '@/components/common/IbanInput.vue'
import { normalizeIban } from '@/helpers/iban'

import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'iban-input': IbanInput
  },

  created () {
    // const defaultBankAccount = this.$engine.bankAccounts.get().find(elem => elem.isDefault === '1')
    // if (defaultBankAccount) {
    //   this.creditorBank = defaultBankAccount.iban
    //   this.creditorBankName = defaultBankAccount.name
    //   this.zoneCode = defaultBankAccount.zoneCode
    //
    // // this.cdtr_name = this.creditorBankName || ''
    this.getMandat()
  },

  data () {
    return {
      showUmrControls: false,   // ← masque l’IHM UMR
      umrAutoChecked: true,   // auto coché par défaut
      umrManualChecked: false,     // 'auto' par défaut
      umrManual: '',       // valeur quand mode manuel
      // IHM
      active: 'one_off', // one_off | recurrent
      active_schema: 'core',
      mandateLang: 'fr',
      mandateLanguageOptions: [
        { value: 'en', label: 'Anglais' },
        { value: 'es', label: 'Espagnol' },
        { value: 'fr', label: 'Français' },
        { value: 'it', label: 'Italien' },
        { value: 'pt', label: 'Portugais' }
      ],
      ctr: '',

      dbtr_name: '',
      dbtr_email: '',
      dbtr_iban: '',
      dbtr_addr: '',
      dbtr_city: '',
      dbtr_ctry: '',
      dbtr_phone: '',
      signatureMode: '',
      showDocusignMode: false,
      docusignMode: 'url',


      cdtr_ref_name: '',
      cdtr_ref_id: '',
      cdtr_addrss: '',
      cdtr_city: '',
      cdtr_ctry: '',
      cdtr_id: '',
      cdtr_name: '',

      //identifiant national brut (pour calcul ICS)
      cdtr_identifier: '',

      countryOptions: [
        { value: 'France',             key: 'france' },
        { value: 'Allemagne',          key: 'allemagne' },
        { value: 'Italie',             key: 'italie' },
        { value: 'Espagne',            key: 'espagne' },
        { value: 'Belgique',           key: 'belgique' },
        { value: 'Luxembourg',         key: 'luxembourg' },
        { value: 'Pays-Bas',           key: 'pays_bas' },
        { value: 'Portugal',           key: 'portugal' },
        { value: 'Irlande',            key: 'irlande' },
        { value: 'Autriche',           key: 'autriche' },
        { value: 'Finlande',           key: 'finlande' },
        { value: 'Suède',              key: 'suede' },
        { value: 'Danemark',           key: 'danemark' },
        { value: 'Norvège',            key: 'norvege' },
        { value: 'Islande',            key: 'islande' },
        { value: 'Suisse',             key: 'suisse' },
        { value: 'Pologne',            key: 'pologne' },
        { value: 'République tchèque', key: 'republique_tcheque' },
        { value: 'Slovaquie',          key: 'slovaquie' },
        { value: 'Slovénie',           key: 'slovenie' },
        { value: 'Croatie',            key: 'croatie' },
        { value: 'Estonie',            key: 'estonie' },
        { value: 'Lettonie',           key: 'lettonie' },
        { value: 'Lituanie',           key: 'lituanie' },
        { value: 'Malte',              key: 'malte' },
        { value: 'Chypre',             key: 'chypre' },
        { value: 'Roumanie',           key: 'roumanie' },
        { value: 'Bulgarie',           key: 'bulgarie' },
        { value: 'Hongrie',            key: 'hongrie' },
        { value: 'Grèce',              key: 'grece' }
      ],



      // internes
      creditorAddress: '',
      creditorBank: '',
      creditorBankName: '',
      zoneCode: '',
      activateSpinner: false,
      isSubmitting: false
    }
  },

  computed: {
    type() { return this.$route.params.type },
    isCdtr() { return this.type === 'cdtr' },
    isDbtr() { return this.type === 'dbtr' },
    isDisabled() { return this.isDbtr },

    // Validation minimale pour activer le bouton Send
    isFormValid() {
      const hasTx = ['one_off', 'recurrent'].includes(this.active)
      const hascdrtName = (this.cdtr_name || '').trim().length > 0
      const hascdtrId = (this.cdtr_id || '').trim().length > 0
      const hasEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.dbtr_email || '')
      const hasDbtrName = (this.dbtr_name || '').trim().length > 0
      const hasDbtrAddr = (this.dbtr_addr || '').trim().length > 0
      const hasDbtrCity = (this.dbtr_city || '').trim().length > 0
      const hasDbtrCtry = (this.dbtr_ctry || '').trim().length > 0
      const hasDbtrPhone = this.isValidEuropeanPhone(this.dbtr_phone)
      //const hasDbtrPhone = (this.dbtr_phone || '').trim().length > 0
      const umrOk = this.umrManualChecked ? (this.umrManual || '').trim().length > 0 : true
      const hasSignatureMode = ['docusign', 'openwens'].includes(this.signatureMode)
      //const hasDocusignMode = this.signatureMode !== 'docusign' || ['url', 'sms'].includes(this.docusignMode)

      return hasTx && hasEmail && hasDbtrName && hasDbtrAddr && hasDbtrCity &&
        hasDbtrCtry && hasDbtrPhone && umrOk && hascdtrId && hascdrtName && hasSignatureMode

      //return hasTx && hasEmail && hasDbtrName && hasDbtrAddr && hasDbtrCity &&
      //  hasDbtrCtry && hasDbtrPhone && umrOk && hascdtrId && hascdrtName && hasSignatureMode && hasDocusignMode
    },

    // Mapping : 1 = one_off, 2 = recurrent
    txType() {
      return this.active === 'one_off' ? 1 : 2
    },
    schemaCode() {
      return this.active_schema === 'core' ? "CORE" : "B2B"
    }
  },

  methods: {
      // appelé quand on change la checkbox "Auto"
    onUmrAutoChange(checked) {
      // b-form-checkbox émet l'événement avec la valeur booléenne du nouvel état
      this.umrAutoChecked = !!checked
      if (this.umrAutoChecked) {
        // décocher manuelle et vider la valeur
        this.umrManualChecked = false
        this.umrManual = ''
      }
    },

    onPhoneInput(value) {
      this.dbtr_phone = String(value || '')
        .replace(/[^0-9 .-]/g, '')
    },

    // appelé quand on change la checkbox "Manuelle"
    onUmrManualChange(checked) {
      this.umrManualChecked = !!checked
      if (this.umrManualChecked) {
        // décocher auto
        this.umrAutoChecked = false
      } else {
        // si décochée et auto non coché, remettre auto par défaut (optionnel)
        if (!this.umrAutoChecked) this.umrAutoChecked = true
      }
    },
    getMandat (index = 0) {
      const params = {}
      this.$engine.Mandat.getMandat(params)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data : {}
          const rawList = Array.isArray(payload.Mandates) ? payload.Mandates : []
          const selected = rawList[index] || {}

          const crtInfo = payload.crt_info || {}
          const crt = Object.keys(crtInfo).reduce((acc, k) => {
            acc[k.trim()] = crtInfo[k]
            return acc
          }, {})

          const crtCity   = crt.cdtr_city ?? ''
          const crtAddr   = crt.cdtr_address ?? crt.cdtr_addr ?? ''
          const crtName   = crt.cdtr_name ?? ''
          const countryFullName    = crt.cdtr_country ?? ''   // "France"
          const creditorIdentifier = crt.cdtr_identifier ?? '' // "504226648"

          // Affichage / pré-remplissage
          this.cdtr_addrss    = crtAddr || selected.cdtr_addr || this.cdtr_addrss
          this.cdtr_city      = crtCity || selected.cdtr_city || this.cdtr_city
          this.cdtr_name      = crtName || selected.cdtr_name || this.cdtr_name
          this.cdtr_ctry      = countryFullName || this.cdtr_ctry
          this.cdtr_identifier = creditorIdentifier || this.cdtr_identifier

          // Calcul ICS → alimente cdtr_id
          const computedICS = this.computeICSFrom(this.cdtr_ctry, this.cdtr_identifier, 'ZZZ')
          this.cdtr_id = computedICS || selected.cdtr_id || this.cdtr_id

          this.$f7?.pullToRefreshDone?.()
          this.activateSpinner = false
        })
        .catch(error => {
          this.activateSpinner = false
          console.error(error)
        })
    },

    onCountryChange() {
     // Quand l’utilisateur change le pays du créancier,
     // on recalcule automatiquement l’ICS (cdtr_id)
     const countryFullName = (this.cdtr_ctry || '').trim()
     const nationalIdRaw   = (this.cdtr_identifier || '').trim()

     const newICS = this.computeICSFrom(countryFullName, nationalIdRaw, 'ZZZ')

     // si le calcul échoue -> on vide l’ID (ou tu peux décider de garder l’ancien)
     this.cdtr_id = newICS || ''
   },

   isValidEuropeanPhone(phone) {
    if (!phone) return false

    const raw = String(phone).trim()

    // Seulement chiffres, espaces, points et tirets
    if (!/^[0-9 .-]+$/.test(raw)) return false

    // Suppression de la mise en forme
    const normalized = raw.replace(/\D/g, '')

    // Doit commencer par 0
    // et contenir entre 7 et 15 chiffres
    return /^0\d{6,14}$/.test(normalized)
  },


   async onSend() {
      if (!this.isFormValid || this.isSubmitting) return
      // --- Validation IBAN via le composant ---
      const rawIban = this.dbtr_iban || ''
      const normIban = normalizeIban(rawIban)
      if (normIban) {
        const ibanComp = this.$refs.dbtrIbanInput
        if (ibanComp) {
          const ok = ibanComp.validate(true)  // affiche l’erreur sous le champ si besoin
          if (!ok) {
            const ibanComp = this.$refs.dbtrIbanInput
            const msg = (ibanComp && ibanComp.error) ||
                        (this.$t && this.$t('errors.iban_invalid')) ||
                        'IBAN invalide'

            this.$f7.modal({
              title: this.$t('common.error') || 'Erreur',
              text: msg,
              buttons: [{ text: 'OK' }]
            })
            return
          }
        }
      }
      this.isSubmitting = true

      try {
        // normaliser / préparer les valeurs (trim)
        const dbtrIban = (this.dbtr_iban || '').trim()
        const dbtrAddr = (this.dbtr_addr || '').trim()
        const dbtrCity = (this.dbtr_city || '').trim()
        const dbtrCtryISO2 = this.countryNameToISO2(this.dbtr_ctry)
        const dbtrPhone = String(this.dbtr_phone || '').replace(/\D/g, '')
        //const dbtrPhone = (this.dbtr_phone || '').trim()
        const cdtrAddrss = (this.cdtr_addrss || '').trim()
        const cdtrCity = (this.cdtr_city || '').trim()
        const cdtrCtry = (this.cdtr_ctry || '').trim()
        const umrManualTrimmed = (this.umrManual || '').trim()
        const cdtrCtryISO2 = this.countryNameToISO2(this.cdtr_ctry)
        const ctrTrimmed = (this.ctr || '').trim()
        const cdtrRefNameTrimmed = (this.cdtr_ref_name || '').trim()
        const cdtrRefIdTrimmed = (this.cdtr_ref_id || '').trim()

        // construire params en n'envoyant que les champs remplis
        const params = {
          ...(ctrTrimmed ? { id_contract: ctrTrimmed } : {}),
          type_transaction: this.txType,
          lang: this.mandateLang.toUpperCase(),
          dbtr_name: (this.dbtr_name || '').trim(),
          dbtr_email: (this.dbtr_email || '').trim(),
          dbtr_addr: dbtrAddr,
          dbtr_city: dbtrCity,
          dbtr_ctry: dbtrCtryISO2,
          dbtr_phone: dbtrPhone,

          // IBAN optionnel (n'envoyer que s'il y a une valeur)
          ...(dbtrIban ? { dbtr_iban: dbtrIban } : {}),

          // Mode de signature :
          // 1 = DocuSign URL, 2 = DocuSign SMS, 3 = OpenWens
          mode_sign: this.signatureMode === 'docusign' ? 1 : 3,

          // CHAMPS créancier demandés :
          // on envoie la variable telle qu'elle est utilisée dans  IHM (cdtr_addrss),
          // et aussi les variantes courantes (cdtr_address / cdtr_addr) si l'API en a besoin.
          ...(cdtrAddrss ? { cdtr_addrss: cdtrAddrss, cdtr_address: cdtrAddrss, cdtr_addr: cdtrAddrss } : {}),
          ...(cdtrCity ? { cdtr_city: cdtrCity } : {}),
          ...(cdtrCtryISO2 ? { cdtr_ctry: cdtrCtryISO2 } : {}),

          // Nom et identifiant créancier déjà calculés
          ...(this.cdtr_name ? { cdtr_name: this.cdtr_name } : {}),
          ...(this.cdtr_id ? { cdtr_id: this.cdtr_id } : {}),

          schema_code: this.schemaCode,

          // UMR
          UMR_auto: this.umrAutoChecked ? 1 : 0,
          UMR_m: this.umrManualChecked ? umrManualTrimmed : ''
        }
        if (cdtrRefNameTrimmed) {
          params.cdtr_ref_name = cdtrRefNameTrimmed
        }
        if (cdtrRefIdTrimmed) {
          params.cdtr_ref_id = cdtrRefIdTrimmed
        }

        // Le backend reçoit toutes les informations du mandat + mode_sign.
        // Aucun appel createEnvelope / sendEnvelopeSms n'est déclenché depuis cette page.
        await this.createMandate(params)

        // this.$toast?.show?.(this.$t('mandate.created_success') || 'Mandat créé avec succès')
       // Alerte succès + retour à la liste au clic sur OK
       this.$f7.modal({
         title: this.$t('mandate.created_success') || 'Mandate Created Successfully',
         text: this.$t('mandate.created_success_text') || 'The new mandate has been created successfully.',
         buttons: [
           {
             text: 'OK',
             onClick: () => {

             }
           }
         ]
       })
       loadPage(this, { url: '/mandatpage/unit' })
       this.$bus.$emit('switch-selected-menu', '/mandatpage/unit')
      } catch (e) {
        console.error(e)

        const status = e?.response?.status
        const errorData = e?.response?.data || {}

        // Cas spécifique : correspondance avec la blacklist
        if (status === 422 && errorData.errorCode === 'BLACKLIST_MATCH') {
          const matchedField = errorData.matchedField || ''

          const baseMessage =
            this.$t('mandate.match_blacklist') ||
            "The mandate cannot be created because the debtor's banking information matches a blacklist entry."

          const message = matchedField
            ? `${baseMessage}<br><br>${this.$t('mandate.matched_blacklist_fields') || 'Matched blacklist field(s)'}: <b>${matchedField}</b>`
            : baseMessage

          this.$f7.modal({
            title: this.$t('common.error') || 'Error',
            text: message,
            buttons: [
              {
                text: 'OK'
              }
            ]
          })

          return
        }

        // Autres erreurs
        this.$toast?.show?.(
          this.$t('errors.generic') || 'Une erreur est survenue'
        )
      } finally {
        this.isSubmitting = false
      }
    },

    createMandate(params) {
      return this.$engine.Mandat.createMandate(params)
    },


    // --- ICS helpers (DANS methods !) ---
    countryNameToISO2(name) {
      if (!name) return ''
      const n = name.trim().toLowerCase()
      const map = {
        'france': 'FR',
        'allemagne': 'DE', 'germany': 'DE',
        'italie': 'IT', 'italy': 'IT',
        'espagne': 'ES', 'spain': 'ES',
        'belgique': 'BE', 'belgium': 'BE',
        'luxembourg': 'LU',
        'pays-bas': 'NL', 'pays bas': 'NL', 'netherlands': 'NL',
        'portugal': 'PT',
        'irlande': 'IE', 'ireland': 'IE',
        'autriche': 'AT', 'austria': 'AT',
        'finlande': 'FI', 'finland': 'FI',
        'suède': 'SE', 'suede': 'SE', 'sweden': 'SE',
        'danemark': 'DK', 'denmark': 'DK',
        'norvège': 'NO', 'norvege': 'NO', 'norway': 'NO',
        'islande': 'IS', 'iceland': 'IS',
        'suisse': 'CH', 'switzerland': 'CH',
        'pologne': 'PL', 'poland': 'PL',
        'république tchèque': 'CZ', 'republique tcheque': 'CZ', 'czechia': 'CZ', 'czech republic': 'CZ',
        'slovaquie': 'SK', 'slovakia': 'SK',
        'slovénie': 'SI', 'slovenie': 'SI', 'slovenia': 'SI',
        'croatie': 'HR', 'croatia': 'HR',
        'estonie': 'EE', 'estonia': 'EE',
        'lettonie': 'LV', 'latvia': 'LV',
        'lituanie': 'LT', 'lithuania': 'LT',
        'malte': 'MT', 'malta': 'MT',
        'chypre': 'CY', 'cyprus': 'CY',
        'roumanie': 'RO', 'romania': 'RO',
        'bulgarie': 'BG', 'bulgaria': 'BG',
        'hongrie': 'HU', 'hungary': 'HU',
        'grèce': 'GR', 'grece': 'GR', 'greece': 'GR'
      }
      return map[n] || ''
    },

    normalizeNationalId(cc, raw) {
      if (!raw) return { nid: '', note: '' }
      let nid = String(raw).replace(/\s+/g, '')
      let note = ''

      if (cc === 'FR') {
        const digits = nid.replace(/\D/g, '')
        if (/^\d{14}$/.test(digits)) {
          nid = digits.slice(0, 9) // SIRET → SIREN
          note = `SIRET détecté, SIREN utilisé: ${nid}`
        } else if (/^\d{9}$/.test(digits)) {
          nid = digits
          note = `SIREN utilisé: ${nid}`
        } else {
          return { nid: '', note: 'Identifiant FR invalide (attendu SIREN 9 ou SIRET 14)' }
        }
      } else {
        nid = nid.toUpperCase()
        if (/[^A-Z0-9]/.test(nid)) return { nid: '', note: 'Identifiant national non alphanumérique' }
      }
      return { nid, note }
    },



    lettersToDigits(s) {
      let out = ''
      for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i)
        if (code >= 48 && code <= 57) out += s[i]
        else if (code >= 65 && code <= 90) out += (code - 55)
      }
      return out
    },

    mod97(numStr) {
      let rem = 0
      for (let i = 0; i < numStr.length; i += 7) {
        const part = String(rem) + numStr.substr(i, 7)
        rem = parseInt(part, 10) % 97
      }
      return rem
    },

    computeICSFrom(countryFullName, nationalIdRaw, businessCode = 'ZZZ') {
      const cc = this.countryNameToISO2(countryFullName)
      if (!cc) return ''

      // 1) Normaliser l'identifiant national (FR → SIREN, etc.)
      const { nid } = this.normalizeNationalId(cc, nationalIdRaw)
      if (!nid) return ''

      // 2) On force MINIMUM 15 CHIFFRES après ZZZ
      //    - On ne garde que les chiffres
      //    - On pad à gauche avec des '0' jusqu'à 15
      const nidDigits = String(nid).replace(/\D/g, '')
      const nidPadded15 = nidDigits.padStart(15, '0')

      // 3) Business code (ex: 'ZZZ')
      const b = (businessCode || 'ZZZ').toUpperCase()
      if (!/^[A-Z0-9]{3}$/.test(b)) return ''

      // 4) Calcul des 2 digits de contrôle (mod 97) sur: b + nidPadded15 + cc + "00"
      const rearr = `${b}${nidPadded15}${cc}00`
      const numeric = this.lettersToDigits(rearr)
      const remainder = this.mod97(numeric)
      const check = String(98 - remainder).padStart(2, '0')

      // 5) Retourne ICS: CC + check + b + nidPadded15
      return `${cc}${check}${b}${nidPadded15}`
    }
  }
}
</script>
